import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioSnrsIo } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS_IO: TIdToPageConfigMap = {
  [PageIdStylioSnrsIo.AGE_SNRS_IO]: {
    id: PageIdStylioSnrsIo.AGE_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioSnrsIo.URGE_SNRS_IO]: {
    id: PageIdStylioSnrsIo.URGE_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.HAIR_COLOR_SNRS_IO]: {
    id: PageIdStylioSnrsIo.HAIR_COLOR_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.EYES_COLOR_SNRS_IO]: {
    id: PageIdStylioSnrsIo.EYES_COLOR_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.JEWELRY_SNRS_IO]: {
    id: PageIdStylioSnrsIo.JEWELRY_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.BODY_SHAPE_SNRS_IO]: {
    id: PageIdStylioSnrsIo.BODY_SHAPE_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.STYLIO_TO_HELP_SNRS_IO]: {
    id: PageIdStylioSnrsIo.STYLIO_TO_HELP_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.TALL_SNRS_IO]: {
    id: PageIdStylioSnrsIo.TALL_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.WEIGHT_SNRS_IO]: {
    id: PageIdStylioSnrsIo.WEIGHT_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.URGE_2_SNRS_IO]: {
    id: PageIdStylioSnrsIo.URGE_2_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.SHOPPING_SNRS_IO]: {
    id: PageIdStylioSnrsIo.SHOPPING_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.STYLE_MOST_MATTERS_SNRS_IO]: {
    id: PageIdStylioSnrsIo.STYLE_MOST_MATTERS_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.FAVORITE_COLORS_SNRS_IO]: {
    id: PageIdStylioSnrsIo.FAVORITE_COLORS_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_11_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_11_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_12_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_12_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_13_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_13_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_14_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_14_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_15_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_15_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_16_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_16_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_17_SNRS_IO]: {
    id: PageIdStylioSnrsIo.LIKE_OR_DISLIKE_17_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.STYLES_FEEL_LIKE_YOU_SNRS_IO]: {
    id: PageIdStylioSnrsIo.STYLES_FEEL_LIKE_YOU_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.URGE_4_SNRS_IO]: {
    id: PageIdStylioSnrsIo.URGE_4_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.BRAND_SNRS_IO]: {
    id: PageIdStylioSnrsIo.BRAND_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.FIND_NEW_CLOTHES_SNRS_IO]: {
    id: PageIdStylioSnrsIo.FIND_NEW_CLOTHES_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.NOTHING_TO_WEAR_SNRS_IO]: {
    id: PageIdStylioSnrsIo.NOTHING_TO_WEAR_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.OLD_CLOTHES_SNRS_IO]: {
    id: PageIdStylioSnrsIo.OLD_CLOTHES_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.COMBINE_CLOTHES_SNRS_IO]: {
    id: PageIdStylioSnrsIo.COMBINE_CLOTHES_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.OUTFIT_LOOK_SNRS_IO]: {
    id: PageIdStylioSnrsIo.OUTFIT_LOOK_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.OPTIMIZE_BUDGET_SNRS_IO]: {
    id: PageIdStylioSnrsIo.OPTIMIZE_BUDGET_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.EVERYDAY_LIFESTYLE_SNRS_IO]: {
    id: PageIdStylioSnrsIo.EVERYDAY_LIFESTYLE_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.CLIMAT_SNRS_IO]: {
    id: PageIdStylioSnrsIo.CLIMAT_SNRS_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrsIo.URGE_3_SNRS_IO]: {
    id: PageIdStylioSnrsIo.URGE_3_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.PREPARE_FLOW_SNRS_IO]: {
    id: PageIdStylioSnrsIo.PREPARE_FLOW_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.EMAIL_SNRS_IO]: {
    id: PageIdStylioSnrsIo.EMAIL_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.EMAIL_CONSENT_SNRS_IO]: {
    id: PageIdStylioSnrsIo.EMAIL_CONSENT_SNRS_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrsIo.SUBSCRIPTIONS_SNRS_IO]: {
    id: PageIdStylioSnrsIo.SUBSCRIPTIONS_SNRS_IO,
  },
  [PageIdStylioSnrsIo.CANCEL_OFFER_SNRS_IO]: {
    id: PageIdStylioSnrsIo.CANCEL_OFFER_SNRS_IO,
  },
  [PageIdStylioSnrsIo.AI_STYLIST_UPSELL_SNRS_IO]: {
    id: PageIdStylioSnrsIo.AI_STYLIST_UPSELL_SNRS_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrsIo.SUB_UPSELL_SNRS_IO]: {
    id: PageIdStylioSnrsIo.SUB_UPSELL_SNRS_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrsIo.UPSELL_SNRS_IO]: {
    id: PageIdStylioSnrsIo.UPSELL_SNRS_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrsIo.DOWNLOAD_SNRS_IO]: {
    id: PageIdStylioSnrsIo.DOWNLOAD_SNRS_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
